import NotificationToast from './notification-toast';

export default NotificationToast;
